import { gql } from '@apollo/client';

export const ESCALATE_REPORT = gql`
  mutation escalateReport($reportId: ID!) {
    escalateReport(reportId: $reportId) {
      id
      status
      postId
      reporterId
      reason
      category
      details
      createdAt
      assignedModeratorId
      assignedAt
    }
  }
`;
